<template>
  <div class="view pa24">
    <div class="d-flex">
      <el-row :gutter="24">
        <el-col :xl="24" :lg="16" class="d-flex justify-content-between w100p">
          <div class="d-flex align-items-center">
            <el-input v-model="queryParam.name" class="mb10" style="width: 240px" placeholder="请输入名称"></el-input>
            <el-button class="ml10 mb10" type="primary" @click="getCustomer">搜索</el-button>
            <el-button class="ml10 mb10" type="primary" @click="reset">重置</el-button>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-button class="ml10 mb10" type="primary" @click="handleAddCode">新增原材料类型</el-button>
    <el-table :data="tableData" style="width: 100%;margin-bottom: 20px;" row-key="id" border>
      <el-table-column prop="name" align="center" label="名称" />
      <!-- <el-table-column prop="formulaName" align="center" label="公式">
      </el-table-column>  -->
      <el-table-column prop="type" align="center" label="计量单位">
        <template slot-scope="scope">
          <!-- {{scope.row.type==0?'重量':'质量'}} -->
          <el-tag v-if="scope.row.type==0">重量</el-tag>
          <el-tag v-if="scope.row.type==1">数量</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="intro" align="center" label="描述" />
      <el-table-column prop="createTime" align="center" label="创建时间" />
      <el-table-column align="center" width="200" label="操作">
        <template slot-scope="scope">
          <el-button type="text" @click="edit(scope.row)">编辑</el-button>
          <el-popconfirm confirm-button-text="确定" cancel-button-text="取消" @confirm="del(scope.row)" icon="el-icon-info"
            icon-color="red" title="确定要删除吗？">
            <el-button slot="reference" class="ml10" style="color: #fd634e" type="text">删除</el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>

    <div class="pageBox">
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="pageNum" :page-sizes="[10, 15, 20]" layout="total, sizes, prev, pager, next, jumper" class=""
        :total="total" :pager-count="5" />
    </div>

    <el-dialog :title="title" :visible.sync="dialogFormVisible" append-to-body :close-on-click-modal="false">
      <el-form :model="form" label-width="80px" :rules="rules">
        <el-form-item label="名称" prop="name">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <!-- <el-form-item label="公式">
          <el-select v-model="form.formulaId" placeholder="请选择">
            <el-option v-for="item in formulaList" :key="item.id" :label="item.name+'('+item.formula+')'"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>  -->
        <el-form-item label="计量方式">
          <el-select v-model="form.type" placeholder="请选择">
            <!-- 0-重量，1-质量 -->
            <el-option label="重量" :value="0"></el-option>
            <el-option label="数量" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="描述">
          <el-input v-model="form.intro" type="textarea"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>
<script>
  import { selectAllFormula } from '@/api/storeFormula.js'
  import { selectMaterialTypeList, addMaterialType, delMaterialType } from '@/api/storeMaterialType.js'

  export default {
    components: {},
    props: {},
    data() {
      return {
        queryParam: {
          name: '',
        },
        tableData: [],
        pageSize: 10,
        pageNum: 1,
        total: 0,
        dialogFormVisible: false,
        form: {
          id: '',
          name: '',
          intro: '',
          formulaId: ''
        },
        dynamicTags: ['(', ')', '*', '/', '+', '-'],
        inputVisible: false,
        inputValue: '',
        title: '新增原材料类型',
        formulaList: [],
        rules: {
          name: [
            { required: true, message: '请输入名称', trigger: 'blur' },
          ],
        }
      };
    },
    created() {
      this.getList()
      this.getAllFormula()
    },
    mounted() {
    },
    methods: {
      getAllFormula() {
        selectAllFormula().then(res => {
          if (res.data) {
            this.formulaList = res.data
          }
        })
      },
      edit(row) {
        this.form = row
        this.title = '编辑公式'
        this.dialogFormVisible = true
      },
      del(row) {
        delMaterialType({ id: row.id }).then(res => {
          this.$message.success('删除成功')
          this.getList()
        })
      },
      handleClose(tag) {
        this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
      },
      getCustomer() {
        this.getList()
      },
      handleSizeChange(num) {
        this.pageSize = num;
        this.pageNum = 1;
        this.getList();
      },
      handleCurrentChange(num) {
        this.pageNum = num;
        this.getList();
      },
      handleAddCode(id) {
        this.dialogFormVisible = true
      },
      getList() {
        let params = {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
        }
        params = Object.assign(params, this.queryParam)
        selectMaterialTypeList(params).then(res => {
          this.tableData = res.data.list
          this.total = res.data.total
        })
      },
      reset() {
        this.queryParam.name = ''
        this.getList()
      },
      save() {
        addMaterialType(this.form).then(res => {
          this.$message.success('保存成功')
          this.dialogFormVisible = false
          this.getList()
        })
      }
    }

  }
</script>
<style scoped>
  .el-tag+.el-tag {
    margin-left: 10px;
  }

  .pageBox {
    display: flex;
    justify-content: flex-end;
  }
</style>